import { createContext } from "react"
import type { ExternalFeatureFlag } from "contexts/ExternalFeatureFlag/useExternalFeatureFlag"

export type { ExternalFeatureFlag } from "contexts/ExternalFeatureFlag/useExternalFeatureFlag"

export interface ExternalFeatureFlagContextType {
  flags: ExternalFeatureFlag[] | null | undefined
  isFeatureFlagLoading: boolean
  getCampaign: (flagName: string) => ExternalFeatureFlag | null
  error?: Error
}

const ExternalFeatureFlagContext =
  createContext<ExternalFeatureFlagContextType>({
    flags: [],
    isFeatureFlagLoading: false,
    getCampaign: () => null,
    error: undefined
  })

export default ExternalFeatureFlagContext
